import React, { useState } from 'react';
export const CommissionCalculator = () => {
  const [weddingType, setWeddingType] = useState('local');
  const [budget, setBudget] = useState(100000);
  const [attendees, setAttendees] = useState(500); // Default 500 for local
  const [planningFeeRate, setPlanningFeeRate] = useState(0.12); // 12% default
  const [showDetails, setShowDetails] = useState(false);
  // Calculate destination attendees (25% of local)
  const destinationAttendees = Math.round(attendees * 0.25);
  // Calculate room nights (assuming 2 people per room, 4 nights average stay)
  const roomNights = Math.ceil(destinationAttendees / 2) * 4;
  // Calculate earnings
  const planningFee = budget * planningFeeRate;
  // Destination wedding additional revenue
  const roomRate = 500; // Average room rate
  const roomCommission = 0.1; // 10% commission on rooms
  const roomRevenue = roomNights * roomRate * roomCommission;
  // Updated commission rates - all 10% of budget
  const decorCommission = budget * 0.1; // 10% commission on decor
  const avCommission = budget * 0.1; // 10% commission on AV
  const floralsCommission = budget * 0.1; // 10% commission on florals
  const entertainmentCommission = budget * 0.1; // 10% commission on entertainment
  // Transportation commission: 10% of $40 per person round trip
  const transportationCost = destinationAttendees * 40; // $40 per person
  const transportCommission = transportationCost * 0.1; // 10% commission
  const totalDestinationCommission = planningFee + roomRevenue + decorCommission + avCommission + floralsCommission + transportCommission + entertainmentCommission;
  const totalLocalCommission = planningFee;
  const additionalProfit = totalDestinationCommission - totalLocalCommission;
  return <section id="calculator" className="py-16 md:py-24 bg-limestone-50 relative overflow-hidden" data-id="element-44">
      <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1519167758481-83f550bb49b3?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2048&q=80')] opacity-5 bg-fixed" data-id="element-45"></div>
      <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-46">
        <div className="text-center mb-10 md:mb-16" data-id="element-47">
          <span className="inline-block px-4 py-1 bg-limestone-200 text-limestone-700 rounded-full text-sm font-medium mb-4" data-id="element-48">
            MAXIMIZE YOUR REVENUE
          </span>
          <h2 className="text-4xl md:text-5xl font-serif font-bold mb-4 md:mb-6 text-gray-800 tracking-tight" data-id="element-49">
            Revenue Calculator
          </h2>
          <p className="text-lg md:text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-50">
            See how much more you could earn with destination weddings compared
            to local weddings
          </p>
        </div>
        <div className="max-w-5xl mx-auto backdrop-blur-sm bg-white/90 rounded-xl md:rounded-2xl shadow-lg md:shadow-xl overflow-hidden border border-limestone-200" data-id="element-51">
          <div className="p-4 md:p-8 border-b border-limestone-100" data-id="element-52">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-10" data-id="element-53">
              <div data-id="element-54">
                <h3 className="text-xl md:text-2xl font-serif font-bold mb-6 md:mb-8 text-gray-800 flex items-center" data-id="element-55">
                  <span className="flex items-center justify-center w-7 h-7 md:w-8 md:h-8 bg-limestone-700 text-white rounded-full text-sm mr-3" data-id="element-56">
                    1
                  </span>
                  Wedding Details
                </h3>
                <div className="mb-6 md:mb-8" data-id="element-57">
                  <label className="block text-gray-700 mb-3 text-base md:text-lg font-medium" data-id="element-58">
                    Wedding Type
                  </label>
                  <div className="grid grid-cols-2 gap-3" data-id="element-59">
                    <button className={`py-3 px-4 md:px-6 rounded-lg transition border ${weddingType === 'local' ? 'bg-limestone-700 text-white border-limestone-700 shadow-md' : 'bg-white text-gray-700 border-limestone-200 hover:bg-limestone-50'}`} onClick={() => {
                    setWeddingType('local');
                    setShowDetails(false);
                  }} data-id="element-60">
                      <span className="flex flex-col items-center" data-id="element-61">
                        <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5 mb-1" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-62">
                          <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" data-id="element-63"></path>
                          <polyline points="9 22 9 12 15 12 15 22" data-id="element-64"></polyline>
                        </svg>
                        Local Wedding
                      </span>
                    </button>
                    <button className={`py-3 px-4 md:px-6 rounded-lg transition border ${weddingType === 'destination' ? 'bg-limestone-700 text-white border-limestone-700 shadow-md' : 'bg-white text-gray-700 border-limestone-200 hover:bg-limestone-50'}`} onClick={() => {
                    setWeddingType('destination');
                    setShowDetails(false);
                  }} data-id="element-65">
                      <span className="flex flex-col items-center" data-id="element-66">
                        <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5 mb-1" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-67">
                          <path d="M2 12h2a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H2v-8z" data-id="element-68"></path>
                          <path d="M6 8h2a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6V8z" data-id="element-69"></path>
                          <path d="M10 4h2a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-2V4z" data-id="element-70"></path>
                          <path d="M14 2h2a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2h-2V2z" data-id="element-71"></path>
                          <path d="M18 6h2a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-2V6z" data-id="element-72"></path>
                        </svg>
                        Destination Wedding
                      </span>
                    </button>
                  </div>
                </div>
                <div className="mb-6 md:mb-8" data-id="element-73">
                  <div className="flex justify-between items-center mb-3" data-id="element-74">
                    <label className="text-gray-700 text-base md:text-lg font-medium" data-id="element-75">
                      Number of Attendees
                    </label>
                    <span className="px-3 py-1 bg-limestone-50 text-limestone-700 rounded-full text-sm font-medium border border-limestone-200" data-id="element-76">
                      {attendees} guests
                    </span>
                  </div>
                  <input type="range" min="200" max="800" step="50" value={attendees} onChange={e => setAttendees(parseInt(e.target.value))} className="w-full h-2 bg-limestone-200 rounded-lg appearance-none cursor-pointer" style={{
                  touchAction: 'manipulation'
                }} data-id="element-77" />
                  <div className="flex justify-between mt-2 text-sm text-gray-500" data-id="element-78">
                    <span data-id="element-79">200</span>
                    <span data-id="element-80">800</span>
                  </div>
                  {weddingType === 'destination' && <div className="mt-3 p-3 bg-limestone-50 rounded-lg border border-limestone-200" data-id="element-81">
                      <p className="text-sm text-gray-600 flex items-start" data-id="element-82">
                        <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5 mr-2 text-limestone-700 flex-shrink-0 mt-0.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-83">
                          <circle cx="12" cy="12" r="10" data-id="element-84"></circle>
                          <line x1="12" y1="8" x2="12" y2="12" data-id="element-85"></line>
                          <line x1="12" y1="16" x2="12.01" y2="16" data-id="element-86"></line>
                        </svg>
                        <span data-id="element-87">
                          <span className="font-medium" data-id="element-88">
                            Only {destinationAttendees} guests
                          </span>{' '}
                          will likely attend your destination wedding (25% of
                          local attendance)
                        </span>
                      </p>
                    </div>}
                </div>
                <div className="mb-6 md:mb-8" data-id="element-89">
                  <div className="flex justify-between items-center mb-3" data-id="element-90">
                    <label className="text-gray-700 text-base md:text-lg font-medium" data-id="element-91">
                      Wedding Budget
                    </label>
                    <span className="px-3 py-1 bg-limestone-50 text-limestone-700 rounded-full text-sm font-medium border border-limestone-200" data-id="element-92">
                      ${budget.toLocaleString()}
                    </span>
                  </div>
                  <input type="range" min="50000" max="300000" step="10000" value={budget} onChange={e => setBudget(parseInt(e.target.value))} className="w-full h-2 bg-limestone-200 rounded-lg appearance-none cursor-pointer" style={{
                  touchAction: 'manipulation'
                }} data-id="element-93" />
                  <div className="flex justify-between mt-2 text-sm text-gray-500" data-id="element-94">
                    <span data-id="element-95">$50,000</span>
                    <span data-id="element-96">$300,000</span>
                  </div>
                </div>
                <div className="mb-4" data-id="element-97">
                  <div className="flex justify-between items-center mb-3" data-id="element-98">
                    <label className="text-gray-700 text-base md:text-lg font-medium" data-id="element-99">
                      Planning Fee Rate
                    </label>
                    <span className="px-3 py-1 bg-limestone-50 text-limestone-700 rounded-full text-sm font-medium border border-limestone-200" data-id="element-100">
                      {(planningFeeRate * 100).toFixed(0)}%
                    </span>
                  </div>
                  <input type="range" min="0.10" max="0.15" step="0.01" value={planningFeeRate} onChange={e => setPlanningFeeRate(parseFloat(e.target.value))} className="w-full h-2 bg-limestone-200 rounded-lg appearance-none cursor-pointer" style={{
                  touchAction: 'manipulation'
                }} data-id="element-101" />
                  <div className="flex justify-between mt-2 text-sm text-gray-500" data-id="element-102">
                    <span data-id="element-103">10%</span>
                    <span data-id="element-104">15%</span>
                  </div>
                </div>
              </div>
              <div data-id="element-105">
                <h3 className="text-xl md:text-2xl font-serif font-bold mb-6 md:mb-8 text-gray-800 flex items-center" data-id="element-106">
                  <span className="flex items-center justify-center w-7 h-7 md:w-8 md:h-8 bg-limestone-700 text-white rounded-full text-sm mr-3" data-id="element-107">
                    2
                  </span>
                  Revenue Details
                </h3>
                <div className="h-full flex flex-col justify-center" data-id="element-108">
                  {weddingType === 'destination' ? <div className="bg-limestone-50 p-4 md:p-6 rounded-lg border border-limestone-200 shadow-sm" data-id="element-109">
                      <h4 className="font-serif font-bold text-lg md:text-xl mb-4 md:mb-5 text-gray-800 flex items-center" data-id="element-110">
                        <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5 mr-2 text-limestone-700" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-111">
                          <circle cx="12" cy="12" r="10" data-id="element-112"></circle>
                          <path d="M8 14s1.5 2 4 2 4-2 4-2" data-id="element-113"></path>
                          <line x1="9" y1="9" x2="9.01" y2="9" data-id="element-114"></line>
                          <line x1="15" y1="9" x2="15.01" y2="9" data-id="element-115"></line>
                        </svg>
                        Destination Wedding Details
                      </h4>
                      <div className="space-y-4" data-id="element-116">
                        <div className="flex justify-between items-center" data-id="element-117">
                          <span className="text-gray-700 flex items-center" data-id="element-118">
                            <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4 mr-2" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-119">
                              <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" data-id="element-120"></path>
                              <circle cx="9" cy="7" r="4" data-id="element-121"></circle>
                              <path d="M23 21v-2a4 4 0 0 0-3-3.87" data-id="element-122"></path>
                              <path d="M16 3.13a4 4 0 0 1 0 7.75" data-id="element-123"></path>
                            </svg>
                            Expected Attendees:
                          </span>
                          <span className="font-medium text-limestone-800" data-id="element-124">
                            {destinationAttendees} people
                          </span>
                        </div>
                        <div className="bg-white p-3 md:p-4 rounded-lg border border-limestone-200 shadow-sm" data-id="element-125">
                          <div className="flex justify-between items-center mb-2" data-id="element-126">
                            <span className="text-gray-700 flex items-center" data-id="element-127">
                              <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4 mr-2" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-128">
                                <path d="M2 4v16l20-8-20-8z" data-id="element-129"></path>
                              </svg>
                              Total Room Nights:
                            </span>
                            <span className="font-medium text-limestone-800" data-id="element-130">
                              {roomNights}
                            </span>
                          </div>
                          <div className="text-sm text-gray-500 space-y-1 divide-y divide-limestone-100" data-id="element-131">
                            <div className="flex justify-between py-1" data-id="element-132">
                              <span data-id="element-133">Rooms needed:</span>
                              <span data-id="element-134">
                                {Math.ceil(destinationAttendees / 2)} rooms
                              </span>
                            </div>
                            <div className="flex justify-between py-1" data-id="element-135">
                              <span data-id="element-136">Average stay:</span>
                              <span data-id="element-137">4 nights</span>
                            </div>
                            <div className="flex justify-between py-1" data-id="element-138">
                              <span data-id="element-139">Room rate:</span>
                              <span data-id="element-140">${roomRate}/night</span>
                            </div>
                            <div className="flex justify-between py-1" data-id="element-141">
                              <span data-id="element-142">Your commission:</span>
                              <span data-id="element-143">{roomCommission * 100}%</span>
                            </div>
                          </div>
                        </div>
                        <div className="p-3 md:p-4 bg-limestone-700 text-white rounded-lg shadow-sm" data-id="element-144">
                          <div className="flex justify-between items-center" data-id="element-145">
                            <span className="flex items-center" data-id="element-146">
                              <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4 mr-2" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-147">
                                <rect x="2" y="7" width="20" height="14" rx="2" ry="2" data-id="element-148"></rect>
                                <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" data-id="element-149"></path>
                              </svg>
                              Room Commission:
                            </span>
                            <span className="font-bold" data-id="element-150">
                              $
                              {roomRevenue.toLocaleString(undefined, {
                            maximumFractionDigits: 0
                          })}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="mt-5 pt-3 md:pt-4 border-t border-limestone-200" data-id="element-151">
                        <p className="text-sm text-gray-600 flex items-start" data-id="element-152">
                          <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5 mr-2 text-limestone-700 flex-shrink-0 mt-0.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-153">
                            <circle cx="12" cy="12" r="10" data-id="element-154"></circle>
                            <line x1="12" y1="16" x2="12" y2="12" data-id="element-155"></line>
                            <line x1="12" y1="8" x2="12.01" y2="8" data-id="element-156"></line>
                          </svg>
                          <span data-id="element-157">
                            Destination weddings typically include multiple
                            revenue streams beyond your planning fee, including
                            commissions on rooms, decor, entertainment, and
                            more.
                          </span>
                        </p>
                      </div>
                    </div> : <div className="bg-limestone-50 p-4 md:p-6 rounded-lg border border-limestone-200 shadow-sm h-full flex flex-col justify-center" data-id="element-158">
                      <h4 className="font-serif font-bold text-lg md:text-xl mb-4 md:mb-5 text-gray-800 flex items-center" data-id="element-159">
                        <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5 mr-2 text-limestone-700" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-160">
                          <circle cx="12" cy="12" r="10" data-id="element-161"></circle>
                          <line x1="8" y1="15" x2="16" y2="15" data-id="element-162"></line>
                          <line x1="9" y1="9" x2="9.01" y2="9" data-id="element-163"></line>
                          <line x1="15" y1="9" x2="15.01" y2="9" data-id="element-164"></line>
                        </svg>
                        Local Wedding Details
                      </h4>
                      <div className="bg-white p-3 md:p-4 rounded-lg border border-limestone-200 shadow-sm mb-4 md:mb-5" data-id="element-165">
                        <div className="flex justify-between items-center" data-id="element-166">
                          <span className="text-gray-700 flex items-center" data-id="element-167">
                            <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4 mr-2" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-168">
                              <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" data-id="element-169"></path>
                              <circle cx="9" cy="7" r="4" data-id="element-170"></circle>
                              <path d="M23 21v-2a4 4 0 0 0-3-3.87" data-id="element-171"></path>
                              <path d="M16 3.13a4 4 0 0 1 0 7.75" data-id="element-172"></path>
                            </svg>
                            Expected Attendees:
                          </span>
                          <span className="font-medium text-limestone-800" data-id="element-173">
                            {attendees} people
                          </span>
                        </div>
                      </div>
                      <div className="p-3 md:p-4 bg-limestone-700 text-white rounded-lg shadow-sm mb-4 md:mb-5" data-id="element-174">
                        <div className="flex justify-between items-center" data-id="element-175">
                          <span className="flex items-center" data-id="element-176">
                            <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4 mr-2" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-177">
                              <line x1="12" y1="1" x2="12" y2="23" data-id="element-178"></line>
                              <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" data-id="element-179"></path>
                            </svg>
                            Planning Fee ({(planningFeeRate * 100).toFixed(0)}
                            %):
                          </span>
                          <span className="font-bold" data-id="element-180">
                            $
                            {planningFee.toLocaleString(undefined, {
                          maximumFractionDigits: 0
                        })}
                          </span>
                        </div>
                      </div>
                      <div className="mt-auto pt-3 md:pt-4 border-t border-limestone-200" data-id="element-181">
                        <p className="text-sm text-gray-600 flex items-start" data-id="element-182">
                          <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5 mr-2 text-limestone-700 flex-shrink-0 mt-0.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-183">
                            <circle cx="12" cy="12" r="10" data-id="element-184"></circle>
                            <line x1="12" y1="16" x2="12" y2="12" data-id="element-185"></line>
                            <line x1="12" y1="8" x2="12.01" y2="8" data-id="element-186"></line>
                          </svg>
                          <span data-id="element-187">
                            Local weddings typically generate revenue primarily
                            through your planning fee, which is usually 10-15%
                            of the total wedding budget.
                          </span>
                        </p>
                      </div>
                    </div>}
                </div>
              </div>
            </div>
          </div>
          <div className="p-4 md:p-8 bg-white" data-id="element-188">
            <h3 className="text-xl md:text-2xl font-serif font-bold mb-6 md:mb-8 text-gray-800 flex items-center" data-id="element-189">
              <span className="flex items-center justify-center w-7 h-7 md:w-8 md:h-8 bg-limestone-700 text-white rounded-full text-sm mr-3" data-id="element-190">
                3
              </span>
              Revenue Comparison
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8" data-id="element-191">
              <div className="bg-limestone-50 p-4 md:p-6 rounded-lg border border-limestone-200 shadow-sm transition-all duration-300 hover:shadow-md" data-id="element-192">
                <div className="flex items-center justify-between mb-4" data-id="element-193">
                  <h3 className="text-lg md:text-xl font-serif font-bold text-gray-800 flex items-center" data-id="element-194">
                    <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5 mr-2 text-limestone-700" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-195">
                      <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" data-id="element-196"></path>
                      <polyline points="9 22 9 12 15 12 15 22" data-id="element-197"></polyline>
                    </svg>
                    Local Wedding Revenue
                  </h3>
                  <span className="px-3 py-1 bg-limestone-100 text-limestone-800 rounded-full text-sm font-medium" data-id="element-198">
                    Basic
                  </span>
                </div>
                <div className="space-y-4" data-id="element-199">
                  <div className="bg-white p-3 md:p-4 rounded-lg border border-limestone-200 shadow-sm" data-id="element-200">
                    <div className="flex justify-between items-center" data-id="element-201">
                      <span className="text-gray-700 flex items-center text-sm md:text-base" data-id="element-202">
                        <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4 mr-2 flex-shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-203">
                          <line x1="12" y1="1" x2="12" y2="23" data-id="element-204"></line>
                          <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" data-id="element-205"></path>
                        </svg>
                        <span className="flex-grow" data-id="element-206">
                          Planning Fee ({(planningFeeRate * 100).toFixed(0)}% of
                          budget)
                        </span>
                      </span>
                      <span className="text-lg md:text-xl font-medium text-gray-800 ml-2" data-id="element-207">
                        $
                        {planningFee.toLocaleString(undefined, {
                        maximumFractionDigits: 0
                      })}
                      </span>
                    </div>
                  </div>
                  <div className="p-3 md:p-4 bg-limestone-700 text-white rounded-lg shadow-sm" data-id="element-208">
                    <div className="flex justify-between items-center" data-id="element-209">
                      <span className="font-medium flex items-center" data-id="element-210">
                        <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4 mr-2 flex-shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-211">
                          <line x1="12" y1="1" x2="12" y2="23" data-id="element-212"></line>
                          <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" data-id="element-213"></path>
                        </svg>
                        Total Revenue
                      </span>
                      <span className="text-xl md:text-2xl font-bold" data-id="element-214">
                        $
                        {totalLocalCommission.toLocaleString(undefined, {
                        maximumFractionDigits: 0
                      })}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="bg-limestone-50 p-4 md:p-6 rounded-lg border border-limestone-200 shadow-sm transition-all duration-300 hover:shadow-md" data-id="element-215">
                <div className="flex items-center justify-between mb-4" data-id="element-216">
                  <h3 className="text-lg md:text-xl font-serif font-bold text-gray-800 flex items-center" data-id="element-217">
                    <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5 mr-2 text-limestone-700" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-218">
                      <path d="M2 12h2a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H2v-8z" data-id="element-219"></path>
                      <path d="M6 8h2a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6V8z" data-id="element-220"></path>
                      <path d="M10 4h2a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-2V4z" data-id="element-221"></path>
                      <path d="M14 2h2a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2h-2V2z" data-id="element-222"></path>
                      <path d="M18 6h2a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-2V6z" data-id="element-223"></path>
                    </svg>
                    Destination Wedding Revenue
                  </h3>
                  <span className="px-3 py-1 bg-limestone-700 text-white rounded-full text-sm font-medium" data-id="element-224">
                    EPA+
                  </span>
                </div>
                <div className="space-y-4" data-id="element-225">
                  <div className="bg-white p-3 md:p-4 rounded-lg border border-limestone-200 shadow-sm" data-id="element-226">
                    <div className="flex justify-between items-center" data-id="element-227">
                      <span className="text-gray-700 flex items-center text-sm md:text-base" data-id="element-228">
                        <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4 mr-2 flex-shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-229">
                          <line x1="12" y1="1" x2="12" y2="23" data-id="element-230"></line>
                          <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" data-id="element-231"></path>
                        </svg>
                        <span className="flex-grow" data-id="element-232">
                          Planning Fee ({(planningFeeRate * 100).toFixed(0)}% of
                          budget)
                        </span>
                      </span>
                      <span className="text-lg md:text-xl font-medium text-gray-800 ml-2" data-id="element-233">
                        $
                        {planningFee.toLocaleString(undefined, {
                        maximumFractionDigits: 0
                      })}
                      </span>
                    </div>
                  </div>
                  {!showDetails ? <div className="bg-white p-3 md:p-4 rounded-lg border border-limestone-200 shadow-sm" data-id="element-234">
                      <div className="flex justify-between items-center" data-id="element-235">
                        <span className="text-gray-700 flex items-center text-sm md:text-base" data-id="element-236">
                          <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4 mr-2 flex-shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-237">
                            <line x1="8" y1="6" x2="21" y2="6" data-id="element-238"></line>
                            <line x1="8" y1="12" x2="21" y2="12" data-id="element-239"></line>
                            <line x1="8" y1="18" x2="21" y2="18" data-id="element-240"></line>
                            <line x1="3" y1="6" x2="3.01" y2="6" data-id="element-241"></line>
                            <line x1="3" y1="12" x2="3.01" y2="12" data-id="element-242"></line>
                            <line x1="3" y1="18" x2="3.01" y2="18" data-id="element-243"></line>
                          </svg>
                          <span className="flex-grow" data-id="element-244">
                            Additional Revenue Streams
                          </span>
                        </span>
                        <span className="text-lg md:text-xl font-medium text-gray-800 ml-2" data-id="element-245">
                          $
                          {(totalDestinationCommission - planningFee).toLocaleString(undefined, {
                        maximumFractionDigits: 0
                      })}
                        </span>
                      </div>
                    </div> : <div className="bg-white p-3 md:p-4 rounded-lg border border-limestone-200 shadow-sm space-y-2" data-id="element-246">
                      <div className="flex justify-between items-center py-1 border-b border-limestone-100" data-id="element-247">
                        <span className="text-gray-600 flex items-center text-xs md:text-sm" data-id="element-248">
                          <svg xmlns="http://www.w3.org/2000/svg" className="w-3 h-3 md:w-4 md:h-4 mr-1 md:mr-2 flex-shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-249">
                            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" data-id="element-250"></path>
                            <circle cx="12" cy="7" r="4" data-id="element-251"></circle>
                          </svg>
                          <span className="flex-grow" data-id="element-252">
                            Room Commissions ({roomNights} nights)
                          </span>
                        </span>
                        <span className="text-gray-800 font-medium ml-1" data-id="element-253">
                          $
                          {roomRevenue.toLocaleString(undefined, {
                        maximumFractionDigits: 0
                      })}
                        </span>
                      </div>
                      <div className="flex justify-between items-center py-1 border-b border-limestone-100" data-id="element-254">
                        <span className="text-gray-600 flex items-center text-xs md:text-sm" data-id="element-255">
                          <svg xmlns="http://www.w3.org/2000/svg" className="w-3 h-3 md:w-4 md:h-4 mr-1 md:mr-2 flex-shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-256">
                            <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" data-id="element-257"></path>
                            <line x1="3" y1="6" x2="21" y2="6" data-id="element-258"></line>
                            <path d="M16 10a4 4 0 0 1-8 0" data-id="element-259"></path>
                          </svg>
                          <span className="flex-grow" data-id="element-260">
                            Decor Commissions (10%)
                          </span>
                        </span>
                        <span className="text-gray-800 font-medium ml-1" data-id="element-261">
                          $
                          {decorCommission.toLocaleString(undefined, {
                        maximumFractionDigits: 0
                      })}
                        </span>
                      </div>
                      <div className="flex justify-between items-center py-1 border-b border-limestone-100" data-id="element-262">
                        <span className="text-gray-600 flex items-center text-xs md:text-sm" data-id="element-263">
                          <svg xmlns="http://www.w3.org/2000/svg" className="w-3 h-3 md:w-4 md:h-4 mr-1 md:mr-2 flex-shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-264">
                            <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5" data-id="element-265"></polygon>
                            <path d="M15.54 8.46a5 5 0 0 1 0 7.07" data-id="element-266"></path>
                            <path d="M19.07 4.93a10 10 0 0 1 0 14.14" data-id="element-267"></path>
                          </svg>
                          <span className="flex-grow" data-id="element-268">
                            AV Commissions (10%)
                          </span>
                        </span>
                        <span className="text-gray-800 font-medium ml-1" data-id="element-269">
                          $
                          {avCommission.toLocaleString(undefined, {
                        maximumFractionDigits: 0
                      })}
                        </span>
                      </div>
                      <div className="flex justify-between items-center py-1 border-b border-limestone-100" data-id="element-270">
                        <span className="text-gray-600 flex items-center text-xs md:text-sm" data-id="element-271">
                          <svg xmlns="http://www.w3.org/2000/svg" className="w-3 h-3 md:w-4 md:h-4 mr-1 md:mr-2 flex-shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-272">
                            <path d="M12 2.69l5.66 5.66a8 8 0 1 1-11.31 0z" data-id="element-273"></path>
                          </svg>
                          <span className="flex-grow" data-id="element-274">
                            Florals Commissions (10%)
                          </span>
                        </span>
                        <span className="text-gray-800 font-medium ml-1" data-id="element-275">
                          $
                          {floralsCommission.toLocaleString(undefined, {
                        maximumFractionDigits: 0
                      })}
                        </span>
                      </div>
                      <div className="flex justify-between items-center py-1 border-b border-limestone-100" data-id="element-276">
                        <span className="text-gray-600 flex items-center text-xs md:text-sm" data-id="element-277">
                          <svg xmlns="http://www.w3.org/2000/svg" className="w-3 h-3 md:w-4 md:h-4 mr-1 md:mr-2 flex-shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-278">
                            <rect x="2" y="7" width="20" height="15" rx="2" ry="2" data-id="element-279"></rect>
                            <polyline points="17 2 12 7 7 2" data-id="element-280"></polyline>
                          </svg>
                          <span className="flex-grow" data-id="element-281">
                            Transportation Commissions (10%)
                          </span>
                        </span>
                        <span className="text-gray-800 font-medium ml-1" data-id="element-282">
                          $
                          {transportCommission.toLocaleString(undefined, {
                        maximumFractionDigits: 0
                      })}
                        </span>
                      </div>
                      <div className="flex justify-between items-center py-1" data-id="element-283">
                        <span className="text-gray-600 flex items-center text-xs md:text-sm" data-id="element-284">
                          <svg xmlns="http://www.w3.org/2000/svg" className="w-3 h-3 md:w-4 md:h-4 mr-1 md:mr-2 flex-shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-285">
                            <circle cx="12" cy="12" r="10" data-id="element-286"></circle>
                            <polygon points="10 8 16 12 10 16 10 8" data-id="element-287"></polygon>
                          </svg>
                          <span className="flex-grow" data-id="element-288">
                            Entertainment Commissions (10%)
                          </span>
                        </span>
                        <span className="text-gray-800 font-medium ml-1" data-id="element-289">
                          $
                          {entertainmentCommission.toLocaleString(undefined, {
                        maximumFractionDigits: 0
                      })}
                        </span>
                      </div>
                    </div>}
                  <div className="p-3 md:p-4 bg-limestone-700 text-white rounded-lg shadow-sm" data-id="element-290">
                    <div className="flex justify-between items-center" data-id="element-291">
                      <span className="font-medium flex items-center" data-id="element-292">
                        <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4 mr-2 flex-shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-293">
                          <line x1="12" y1="1" x2="12" y2="23" data-id="element-294"></line>
                          <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" data-id="element-295"></path>
                        </svg>
                        Total Revenue
                      </span>
                      <span className="text-xl md:text-2xl font-bold" data-id="element-296">
                        $
                        {totalDestinationCommission.toLocaleString(undefined, {
                        maximumFractionDigits: 0
                      })}
                      </span>
                    </div>
                  </div>
                  <button onClick={() => setShowDetails(!showDetails)} className="w-full py-2 px-4 bg-white text-gray-700 border border-limestone-200 rounded-lg hover:bg-limestone-50 transition text-sm flex items-center justify-center" data-id="element-297">
                    {showDetails ? <>
                        <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4 mr-2" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-298">
                          <polyline points="18 15 12 9 6 15" data-id="element-299"></polyline>
                        </svg>
                        Hide Revenue Details
                      </> : <>
                        <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4 mr-2" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-300">
                          <polyline points="6 9 12 15 18 9" data-id="element-301"></polyline>
                        </svg>
                        Show Revenue Breakdown
                      </>}
                  </button>
                </div>
              </div>
            </div>
            <div className="mt-6 md:mt-8 p-4 md:p-8 bg-white rounded-xl border-2 border-limestone-300 shadow-xl relative" data-id="element-302">
              <div className="flex flex-col md:flex-row justify-between items-center gap-4 md:gap-6" data-id="element-303">
                <div data-id="element-304">
                  <h3 className="text-xl md:text-2xl font-serif font-bold text-gray-800 mb-2 flex items-center" data-id="element-305">
                    <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5 md:w-6 md:h-6 mr-2 text-limestone-700" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-306">
                      <circle cx="12" cy="12" r="10" data-id="element-307"></circle>
                      <path d="M8 14s1.5 2 4 2 4-2 4-2" data-id="element-308"></path>
                      <line x1="9" y1="9" x2="9.01" y2="9" data-id="element-309"></line>
                      <line x1="15" y1="9" x2="15.01" y2="9" data-id="element-310"></line>
                    </svg>
                    Your Profit Difference
                  </h3>
                  <p className="text-gray-600 text-base md:text-lg" data-id="element-311">
                    Destination weddings earn you{' '}
                    <span className="font-bold text-limestone-800" data-id="element-312">
                      {(additionalProfit / totalLocalCommission * 100).toFixed(0)}
                      % more revenue
                    </span>{' '}
                    compared to local weddings
                  </p>
                </div>
                <div className="text-3xl md:text-5xl font-bold text-white bg-limestone-700 px-6 md:px-8 py-4 md:py-5 rounded-xl border-2 border-limestone-600 shadow-lg transform transition-all duration-300 hover:scale-105 hover:shadow-xl relative overflow-hidden" data-id="element-313">
                  <div className="absolute inset-0 bg-gradient-to-r from-limestone-800 to-limestone-600 opacity-50" data-id="element-314"></div>
                  <span className="relative z-10" data-id="element-315">
                    +$
                    {additionalProfit.toLocaleString(undefined, {
                    maximumFractionDigits: 0
                  })}
                  </span>
                  <div className="absolute -top-10 -right-10 w-20 h-20 bg-white opacity-10 rounded-full" data-id="element-316"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="mt-10 md:mt-16 text-center" data-id="element-317">
          <a href="#masterclass-curriculum" className="inline-block bg-limestone-700 hover:bg-limestone-800 text-white font-bold py-3 md:py-4 px-8 md:px-10 rounded-lg text-lg transition transform hover:scale-105 shadow-xl relative overflow-hidden group" data-id="element-318">
            <span className="absolute top-0 left-0 w-full h-full bg-white opacity-0 group-hover:opacity-20 transition-opacity duration-300" data-id="element-319"></span>
            <span className="relative z-10 flex items-center justify-center" data-id="element-320">
              <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5 mr-2" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-321">
                <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" data-id="element-322"></path>
                <circle cx="8.5" cy="7" r="4" data-id="element-323"></circle>
                <line x1="20" y1="8" x2="20" y2="14" data-id="element-324"></line>
                <line x1="23" y1="11" x2="17" y2="11" data-id="element-325"></line>
              </svg>
              Join Our Masterclasses
            </span>
          </a>
        </div>
      </div>
    </section>;
};